module.exports = __webpack_public_path__ + "img/search-img.01411976.jpg";